import React from 'react'
import { replaceAll } from 'src/utils/string'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import Popup from './Popup'
import { makeControlledModal } from 'src/decorators/ModalController'

interface NewsletterSignUpModalProps {
  firstName: string
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  settings: {
    newsletterBodyText: string
    newsletterHeaderText: string
    newsletterCloseButtonText: string
    popupImage: boolean
    showPopupImage: boolean
  }
}

const NewsletterSignUpModal = ({
  firstName,
  settings,
  modal,
  ...props
}: NewsletterSignUpModalProps): JSX.Element => {
  const {
    newsletterBodyText,
    newsletterHeaderText,
    newsletterCloseButtonText,
    popupImage,
    showPopupImage
  } = settings
  const { t } = React.useContext(TranslationContext)
  const getDynamicText = (text: string) => {
    return replaceAll(
      text || '',
      '{{firstName}}',
      firstName || t('Dear Friend')
    )
  }
  return (
    <Popup
      {...props}
      {...modal}
      popupImage={showPopupImage && popupImage}
      headerText={getDynamicText(newsletterHeaderText)}
      bodyText={getDynamicText(newsletterBodyText)}
      closeButtonText={getDynamicText(newsletterCloseButtonText)}
    />
  )
}

export default makeControlledModal(
  NewsletterSignUpModal,
  'NewsletterSignupModal'
)
